import { ColorOption } from './color-option';

export class ColorChooserComponent {
  name: string;
  label: string;
  options: {
    [optionId: string]: ColorOption;
  };
}
